import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { formatPhone } from '../shared/phone';
import { channelLabel, formatFullTimestamp, messageParties } from './inboxFormat';
import { directionLabel } from '../MessageItem';

const STATUS_LABELS = { unconfirmed: 'Unconfirmed', failed: 'Failed' };

const statusLabel = (status) => STATUS_LABELS[status] || (status ? status.charAt(0).toUpperCase() + status.slice(1) : '');

function Party({ side, email }) {
  if (!side) return <span className="text-slate-400">Not recorded</span>;
  const address = email ? side.address : (side.address ? formatPhone(side.address) : '');
  return (
    <span className="break-all">
      {side.label && <span className="font-medium">{side.label}</span>}
      {side.label && address ? ' · ' : ''}
      {address}
    </span>
  );
}

// Ticket 195: from / to, channel, direction and the full timestamp (with zone)
// for one message — opened from the "Details" link under a bubble.
export default function MessageDetailsDialog({ message, contact, onOpenChange }) {
  const m = message;
  const parties = m ? messageParties(m, contact) : null;
  const email = m?.channel === 'email';
  const subject = m?.ghl?.email?.subject || m?.subject;
  const rows = m ? [
    ['From', <Party side={parties.from} email={email} />],
    ['To', <Party side={parties.to} email={email} />],
    ['Channel', channelLabel(m.channel)],
    ['Direction', directionLabel(m.direction)],
    [m.direction === 'outbound' ? 'Sent' : 'Received', formatFullTimestamp(m.created_at) || '—'],
    ...(m.status ? [['Status', statusLabel(m.status)]] : []),
    ...(email && subject ? [['Subject', subject]] : []),
  ] : [];
  return (
    <Dialog open={!!m} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="message-details">
        <DialogHeader>
          <DialogTitle>Message details</DialogTitle>
          <DialogDescription>Who it went between, and when.</DialogDescription>
        </DialogHeader>
        <dl className="text-sm grid grid-cols-[6rem_1fr] gap-x-3 gap-y-2">
          {rows.map(([label, value]) => (
            <React.Fragment key={label}>
              <dt className="text-slate-500">{label}</dt>
              <dd className="min-w-0" data-testid={`message-details-${label.toLowerCase()}`}>{value}</dd>
            </React.Fragment>
          ))}
        </dl>
      </DialogContent>
    </Dialog>
  );
}
